import { useEffect } from 'react'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { Key, useSWRConfig } from 'swr'

const mountedKeys = new Set<Key>()

const getParsedKey = (key: Key) => {
  return JSON.stringify(typeof key === 'function' ? key() : key)
}

export const useTrackedSWRKey = (key: Key) => {
  const parsedKey = getParsedKey(key)
  useEffect(() => {
    mountedKeys.add(parsedKey)
    return () => {
      mountedKeys.delete(parsedKey)
    }
  }, [parsedKey])
}

export const useRevalidateModules = () => {
  const { mutate, cache } = useSWRConfig()

  const revalidateModules = async (
    modules: RequestModuleEnum[] | string[],
    hardRevalidate = false,
  ) => {
    const shouldHardRevalidate = (key: Key) => hardRevalidate || !mountedKeys.has(getParsedKey(key))

    const allKeys = Array.from(cache.keys())

    for (const key of allKeys) {
      if (typeof key === 'string' && key.startsWith('$inf$')) {
        const matches = modules.some(module => key.includes(module))
        if (matches) {
          await mutate(key)
        }
      }
    }

    await mutate(key => {
      if (!Array.isArray(key)) return false
      const matches = key.some(keyElement => modules.includes(keyElement))
      return matches && shouldHardRevalidate(key)
    }, undefined)

    await mutate(key => {
      if (!Array.isArray(key)) return false
      const matches = key.some(keyElement => modules.includes(keyElement))
      return matches && !shouldHardRevalidate(key)
    })
  }
  return {
    revalidateModules,
  }
}
